import authorizedAPIInstance from '@/api/authorizedAPI';
import { formatAPIError, replacePlaceholders } from '@/utils/helpers';
import type { ProductionLine } from '../utils/types';

export type FacilityByIdInput = {
  facilityId: string;
};

export const fetchFacilityById = async ({
  facilityId,
}: FacilityByIdInput): Promise<ProductionLine> => {
  try {
    const { data } = await authorizedAPIInstance.get<ProductionLine>(
      replacePlaceholders(`/api/facilities/:facilityId`, {
        facilityId,
      })
    );
    return data;
  } catch (error) {
    throw formatAPIError(error);
  }
};
